import { SvgIcon } from './SvgIcon';

export const WarningIcon: SvgIcon = ({
	width = 20,
	height = 20,
	strokeColor = 'text-red-500',
	strokeWidth = 1.2,
	fillColor = '#FF0033'
}) => (
	<svg
		width={width}
		height={height}
		fill={fillColor}
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 20 20"
		className={`stroke-current ${strokeColor}`}
	>
		<path
			fillRule="evenodd"
			d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
			clipRule="evenodd"
			strokeWidth={strokeWidth}
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export const DeleteIcon: SvgIcon = ({
	width = 20,
	height = 20,
	strokeColor = 'text-blue-500',
	strokeWidth = 2,
	fillColor = '#000'
}) => (
	<svg
		width={width}
		height={height}
		fill={fillColor}
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 16 16"
		// className={`stroke-current ${strokeColor}`}
	>
		<path
			strokeWidth={strokeWidth}
			d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"
		/>
		<path
			strokeWidth={strokeWidth}
			fill-rule="evenodd"
			d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
		/>
	</svg>
);

export const EditIcon: SvgIcon = ({
	width = 20,
	height = 20,
	strokeColor = 'text-blue-500',
	strokeWidth = 2,
	fillColor = '#000'
}) => (
	<svg
		width={width}
		height={height}
		fill={fillColor}
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 16 16"
		// className={`stroke-current ${strokeColor}`}
	>
		<path
			strokeWidth={strokeWidth}
			d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z"
		/>
	</svg>
);
